import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BulkActions = ({ 
  selectedCount, 
  onBulkTag, 
  onBulkEdit,
  onBulkDelete,
  onBulkExport, 
  onClearSelection 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const bulkActionOptions = [
    { value: '', label: 'Select bulk action...' },
    { value: 'tag', label: 'Add Tags' },
    { value: 'edit', label: 'Edit Selected' },
    { value: 'delete', label: 'Delete Selected' },
    { value: 'export', label: 'Export Selected' }
  ];

  const handleBulkAction = async () => {
    if (!bulkAction || selectedCount === 0) return;

    setIsProcessing(true);
    
    try {
      switch (bulkAction) {
        case 'tag':
          await onBulkTag();
          break;
        case 'edit':
          await onBulkEdit();
          break;
        case 'delete':
          await onBulkDelete();
          break;
        case 'export':
          await onBulkExport();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('Bulk action failed:', error);
    } finally {
      setIsProcessing(false);
      setBulkAction('');
    }
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
              <Icon name="Check" size={14} color="white" />
            </div>
            <span className="font-medium text-foreground">
              {selectedCount} client{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconPosition="left"
          >
            Clear Selection
          </Button>
        </div>

        <div className="flex items-center space-x-3">
          <div className="w-48">
            <Select
              placeholder="Choose action..."
              options={bulkActionOptions}
              value={bulkAction}
              onChange={setBulkAction}
            />
          </div>
          
          <Button
            variant="default"
            onClick={handleBulkAction}
            disabled={!bulkAction || isProcessing}
            loading={isProcessing}
            iconName="Play"
            iconPosition="left"
          >
            Apply
          </Button>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-primary/20">
        <span className="text-sm text-muted-foreground mr-2">Quick actions:</span>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkTag()}
          iconName="Tag"
          iconPosition="left"
        >
          Add Tags
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkEdit()}
          iconName="Edit"
          iconPosition="left"
        >
          Edit Selected
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkDelete()}
          iconName="Trash2"
          iconPosition="left"
          className="text-destructive hover:text-destructive"
        >
          Delete Selected
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkExport()}
          iconName="Download"
          iconPosition="left"
        >
          Export Data
        </Button>
      </div>
    </div>
  );
};

export default BulkActions;